import { render, staticRenderFns } from "./referralSettings.vue?vue&type=template&id=19c4f114&scoped=true"
import script from "./referralSettings.vue?vue&type=script&lang=js"
export * from "./referralSettings.vue?vue&type=script&lang=js"
import style0 from "./referralSettings.vue?vue&type=style&index=0&id=19c4f114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4f114",
  null
  
)

export default component.exports